var t;(function(n){n.Extension="extension",n.Hosted="hosted"})(t||(t={}));export{t as SignerType};
